import React from "react";
import { useNavigate } from "react-router-dom";
import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import { useAuth } from "../hooks/useAuth";

// #50 — the principal's agent/agency view switch. Only rendered for a principal
// account that is also linked to an agent record (canActAsAgent). Switching sets
// the view mode and navigates to that capacity's landing page: the admin console
// for the agency view, the agent dashboard for the agent view. The backend still
// authorizes by the real role, so this only changes which experience they see.
const ViewModeToggle = () => {
  const { user, canActAsAgent, viewMode, setViewMode } = useAuth();
  const navigate = useNavigate();

  if (!canActAsAgent(user)) return null;

  const change = (_e, mode) => {
    if (!mode || mode === viewMode) return;
    setViewMode(mode);
    navigate(mode === "agent" ? "/" : "/admin");
  };

  return (
    <Tooltip title="Switch between your agency admin view and your own agent view">
      <ToggleButtonGroup
        size="small"
        exclusive
        value={viewMode}
        onChange={change}
        aria-label="View mode"
        sx={{ bgcolor: "background.paper", borderRadius: 2 }}
      >
        <ToggleButton value="agency" aria-label="Agency admin view">
          <BusinessIcon fontSize="small" sx={{ mr: 0.5 }} />
          My Agency
        </ToggleButton>
        <ToggleButton value="agent" aria-label="Agent view">
          <PersonIcon fontSize="small" sx={{ mr: 0.5 }} />
          My Agent View
        </ToggleButton>
      </ToggleButtonGroup>
    </Tooltip>
  );
};

export default ViewModeToggle;
